// PayPalServices.js
// PayPal integration with real API calls

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const createOrder = async (orderData) => {
  const response = await fetch("/api/paypal/create-order", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    throw new Error("Failed to create PayPal order");
  }

};

export const captureOrder = async (orderId, eventID, registrationID) => {
  console.log("Capturing PayPal order:", orderId);
  console.log("Event ID:", eventID);
  console.log("Registration ID:", registrationID);
  const response = await fetch("/api/paypal/capture-order", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ orderId }),
  });

  if (!response.ok) {
    throw new Error("Failed to capture PayPal order");
  }
};

export const getAllTransactions = async (start_date, end_date) => {
  console.log("Fetching PayPal transactions from", start_date, "to", end_date);
try {
    const res = await fetch(
        `${API_URL}/paypal/transactions?start_date=${start_date}&end_date=${end_date}`
    );

    if (!res.ok) throw new Error("Failed to fetch PayPal transactions");

    const data = await res.json();
    console.log("Transactions:", data.transactions);
    return data.transactions;
  } catch (error) {
    throw new Error("Failed to fetch PayPal transactions");
  }
};
  


